export const getHeroMinHeights = (size) => {
  return (
    {
      //Index 0 is the minimum image height for Mobile
      //Index 1 is the minimum image height for Desktop
      tall: ['500px', '720px'],
      medium: ['328px', '548px'],
      short: ['250px', '320px'],
    }[size] || ['auto', 'auto']
  )
}
export const getHeroHalfMinHeights = (size) => {
  return (
    {
      //Index 0 is the minimum image height for Mobile
      //Index 1 is the minimum image height for Desktop
      tall: ['240px', '448px'],
      medium: ['160px', '384px'],
      short: ['112px', '248px'],
    }[size] || ['auto', 'auto']
  )
}

export const getHeroOverlineImageMaxHeights = (size) => {
  return (
    {
      //Index 0 is the maximum image height for Mobile
      //Index 1 is the maximum image height for Desktop
      sm: ['48px', '48px'],
      md: ['96px', '112px'],
      lg: ['256px', '256px'],
      xl: ['320px','424px'],
    }[size] || ['468px', '656px']
  )
}

export const getHeroHalfOverlineImageMaxHeights = (size) => {
  return (
    {
      //Index 0 is the maximum image height for Mobile
      //Index 1 is the maximum image height for Desktop
      sm: ['48px', '48px'],
      md: ['96px', '112px'],
      lg: ['160px', '192px'],
      xl: ['200px','256px'],
    }[size] || ['auto', 'auto']
  )
}
